import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getLoginStateSelector } from '../../../../../redux/selectors/loginSelector'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../components/loader/loader'
import { allRoutes } from '../../../../../utils/routeConstants'
import { useDispatch } from 'react-redux'
import { getRiskAssessmentsById } from '../../../../../redux/risk-assessment/riskAssessmentSlice'
import { getDevice } from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice'
import { getRiskAssessmentLoadingState } from '../../../../../redux/selectors/riskAssessment'
import { sessionAttributes, setItemInSession } from '../../utils/sessionStorage'

export default function ShareDeviceDetails() {
    const [riskAssessmentData, setRiskAssessmentData] = useState('')
    const loginState = useSelector(getLoginStateSelector())
    const loadingState = useSelector(getRiskAssessmentLoadingState())
    const nav = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    const searchParams = new URLSearchParams(location.search)
    const deviceId = searchParams.get('deviceId')
    const riskAssessmentId = searchParams.get('riskAssessmentId')

    useEffect(() => {
        if (riskAssessmentId) {
            dispatch(getRiskAssessmentsById({
                id: riskAssessmentId,
                callback: (result) => {
                    setRiskAssessmentData(result.data)
                }
            }))
        }
    }, [riskAssessmentId])

    useEffect(() => {
        if (riskAssessmentData && deviceId) {
            const selectedProductLine = riskAssessmentData?.product_detail
            const buildState = (device) => ({
                ...location.state,
                selectedDevice: device,
                selectedRiskAssessment: riskAssessmentData,
                selectedProductLine: selectedProductLine,
                selectedModelId: riskAssessmentData?.machine_detail?.[0]?.id,
                selectedModel: riskAssessmentData?.machine_detail?.[0],
                type: riskAssessmentData?.type,
            })

            if (loginState.isLoggedIn && loginState.token) {
                setItemInSession(
                    sessionAttributes.selectedProductLine,
                    JSON.stringify(selectedProductLine),
                );
                dispatch(getDevice({
                    id: deviceId,
                    callback: (device) => {
                        nav(allRoutes.dashboardRoutes.assessmentRoutes.deviceDetails, {
                            state: buildState(device ?? { id: parseInt(deviceId) }),
                        });
                    },
                }))
            } else {
                nav(allRoutes.login, {
                    state: {
                        ...buildState({ id: parseInt(deviceId) }),
                        lastNavLink: window.location.href,
                    }
                })
            }
        }
    }, [riskAssessmentData, deviceId])

    return (
        <div>
            {loadingState && <Loader />}
            {!riskAssessmentId && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No risk assessment ID provided in query parameters</p>
                </div>
            )}
            {!deviceId && (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No device ID provided in query parameters</p>
                </div>
            )}
        </div>
    )
}
